export const confirmInviteAPIConfig = ({ newUser, fullName, phone }) => {
    const requestConfig = newUser
        ? {
            headers: {
                'new-user-invite': true,
            },
            data: {
                full_name: fullName,
                phone,
                is_sign_up_data_complete: true,
            },
        }
        : {
            headers: {},
            data: {},
        };

    return {
        url: '/api/users/me/invite-confirmations',
        method: 'POST',
        headers: requestConfig.headers,
        data: requestConfig.data,
    };
};
